<template>
  <div class="win_item" :class="`item${id} ${onClass}`"> 
    <div class="jl_con">
        <!--普通奖励-->
        <div class="img_wrap" v-for="a in imgArr.filter(item => item.AwardType != 4)" :key="a.index">
          <span class="img_tip" :class="`${getLast(a.Id)}`">{{ getTip(a.AwardId) }}</span>
          <img
              :src="getImg(a.AwardId, a.AwardType)"
              width="60"
              height="60"
            />
            <span class="jl_nums" v-show="a.AwardId > 0 && a.AwardType > 0">{{ a.Amount }}</span>
        </div>
        <!--普通奖励end-->
        <!--特殊奖励英雄皮肤-->
        <div class="img_wrap hero_wrap" v-for="a in imgArr.filter(item => item.AwardType == 4)" :key="a.index">
            <img 
              :src="getHeroImg(thisHeroObj)"
              width="60"
              height="60"
          />
            <!--特殊奖励是拓片的时候显示数量-->
            <!-- <span class="jl_nums" v-show="thisHeroObj!=null && thisHeroObj.HeroId ==0">{{ thisHeroObj.Amount }}</span> -->
            <div class="hero_tips" v-if="thisHeroObj!=null">
              <p class="p1" :class="thisHeroObj.Quality ==4?'red':''">{{thisHeroObj.ItemName}}</p>
              <p v-html="thisHeroObj != null && thisHeroObj.HeroId >0?itemAttr(thisHeroObj.ItemAttrs):getTip(thisHeroObj.ItemId)"></p>
            </div>
            <div class="hero_tips" v-else-if="thisHeroObj ==null">
              <p v-if="id==16">属性皮肤随机池：<br>90%红色（其中红色卓越2%），7%金色，3%无双金色</p>
              <p v-else-if="id==10">属性皮肤随机池：<br>90%红色（其中红色卓越2%），10%金色</p>
            </div>
        </div>
        <!--特殊奖励英雄皮肤end-->
        <div v-if="lightFlash" class="hero_light" :class="{'img_active':lightFlash}"></div>
    </div>
    <div class="win_nums" v-show="!showJLBtn">{{ winMax }}</div>
    <a href="javascript:;" v-show="showJLBtn" class="lq_btn" :class="addClass" @click="getAward(id)"></a>
    <!-- <div class="opa"></div> -->
  </div>
</template>

<script setup>
import http from '@/utils/request';
import getTip from "@/utils/global";
import emitter from '@/utils/bus';
import { ref,defineProps,watch,computed, onMounted} from 'vue';
import {storeToRefs} from 'pinia';
import { useStore } from '../store/index';
const store = useStore();
let {currWinNums,drawFlag,btnState} = storeToRefs(store);
const props = defineProps({
    id: Number,
    imgArr: Array,
    winMax: Number,
    flag: Number,
    heroList:Object,
    val:Number
    
})
const  lightFlash = ref(false);

const thisHeroObj = ref(props.heroList);


//英雄皮肤数据对象
watch(() =>props.heroList, (newValue) => {
  thisHeroObj.value = newValue;
}); 


// let heroattrs = "〡级#00ff00,〢级#eb4b4b,〣级#e6b41e";
//属性暴击判断
const itemAttr = function(attr){
    const t = attr.split(',');
    let attrtext = "";
    t.forEach(function(item){
      if(item.indexOf('〡') != -1){
        attrtext += `<p style="color:#00ff00">${item}</p>`;
      }
      else if(item.indexOf('〢') != -1){
        attrtext += `<p style="color:#eb4b4b">${item}</p>`;
      }
      else if(item.indexOf('〣') != -1){
        attrtext += `<p style="color:#e6b41e">${item}</p>`;
      }
      else{
        attrtext += `<p>${item}</p>`;
      }
    })
    return attrtext;
};
const getLast = function(id){
  if(id==4 || id==8 || id==12 || id==16) return "last";
  return "";
}


  //领取按钮状态
  const showJLBtn = computed(()=>{
      if(currWinNums.value >= props.winMax || (drawFlag.value & props.flag) == props.flag) return true;
      return false;
  })

  const addClass = computed(()=>{
        if ((drawFlag.value & props.flag) == props.flag) return " ylq";
        return "";
  })

  const onClass = computed(()=>{
        if((drawFlag.value & props.flag) == props.flag){
          return "ylq"
        }
        else if (
          currWinNums.value >= props.winMax &&
          (drawFlag.value & props.flag) != props.flag
        ){
          return "on";
        }
       return "cant";
  })

  onMounted(()=>{
   
  })

//获取普通奖励图片
  const getImg = function(AwardId, AwardType){
    if (AwardId > 0 && AwardType > 0) {
        return require(`@/assets/img/${AwardId}_${onClass.value}.png`);
    }
    return ""
  }

//获取特殊奖励图片
  const getHeroImg = function(ele){
   if(ele != null) {
      return `https://pic2.7fgame.com/qxresource/${ele.ItemId}.png`;
   }else{
      if(currWinNums.value < props.winMax){
        return require(`@/assets/img/spec_cant.png`);
      }else{
        return require(`@/assets/img/spec_on.png`)
      }
   }
  }


//领取奖励
  const getAward = function(id){
    if ((drawFlag.value & props.flag) == props.flag) {
        return;
    }
    if(!btnState.value) return;
    btnState.value = false;
     
    http.get("ActTask/DrawActTask", {
          params: {
            Id: id,
          },
        })
        .then((res) => {
          if (res.Code == 0) {
            let delay = 0;
            // drawFlag.value = drawFlag.value | props.flag;
             if(id==10 || id==16){
              lightFlash.value = true;
              delay = 2500;
              setTimeout(function(){
                thisHeroObj.value = JSON.parse(res.Msg);
                store.updateDrawFlag(props.flag);
              },1000)
             }else{
              lightFlash.value = false;
              delay = 0;
              store.updateDrawFlag(props.flag);
             }
             setTimeout(function(){
              lightFlash.value = false;
              btnState.value = true;
              emitter.emit(
                "showaward",{msg:res.Obj,heromsg:res.Msg,msgtype:2, update:drawFlag.value, id:id});
             },delay)
            //  this.$bus.$emit("showaward",res.data.Obj,2,this.thisDrawFlag,id);
            try {
              window.parent.leftDH.isOnceArr[1] = true;
            } catch (e) {
              console.log(e);
            }
          }else{
            btnState.value = true;
            emitter.emit("showaward", {msg:res.Msg, msgtype:3});
          }
      });    
    }
</script>

<style scoped>
.win_item {
  float: left;
  width: 152px;
  position: relative;
  height:488px;
  background: url("../assets/img/li_bg.png") 0 0 no-repeat;
}

.jl_con {
  padding-top:37px;
  position: relative;
  width: 152px;
  height:396px;
}
.win_item .img_wrap{
  position: relative;
  width:60px;
  height: 60px;
  margin: 0 auto 10px;
  text-align:center;
  padding:3px;
  z-index: 3;
  background: url("../assets/img/img_bg.png") 0 0 no-repeat;
}
.item10 .img_wrap.hero_wrap{
  margin-top:101px;
}
.win_item .img_wrap:nth-child(5){
  margin-top:24px;
}
.win_item .hero_wrap .hero_tips{
  background: rgb(24 34 40 / 60%);
    position: absolute;
    color: #fff;
    font-size: 12px;
    line-height: 16px;
    min-width: 120px;
    max-width: 200px;
    display: none;
    z-index: 10;
    padding: 1px 5px;
    border: #212d34 1px solid;
    text-align: left;
    bottom:0;
    left:0;
}
.win_item.item16 .hero_wrap .hero_tips{
  left:auto;
  right:0;
}
.win_item .hero_wrap .hero_tips .p1{
  color:#ffe45f;
}
.win_item .hero_wrap .hero_tips .p1.red{
  color:#ff0000;
}
.win_item.item10 .hero_wrap:hover .hero_tips,.win_item.item16 .hero_wrap:hover .hero_tips{
  display:block;
 
}
.item16 .img_wrap.img_wrap_pf{
  margin-top:12px;
}
.win_item .img_wrap img{
  border-radius: 50%;
}
.win_item .img_wrap .img_tip{
  background: rgb(24 34 40 / 60%);
  position: absolute;
  color:#fff;
  font-size: 12px;
  line-height: 16px;
  min-width: 220px;
  display: none;
  bottom: 0;
  left: 0;
  z-index: 10;
  padding:1px 5px;
  border:#212d34 1px solid;
  text-align: left;
}
.win_item .img_wrap .img_tip.last{
  right: 0;
  left:auto;
}
.win_item:hover{
  z-index: 5;
}
.win_item .img_wrap:hover .img_tip{
  display: block;
}
.win_item .snow_null .spec_wrap{
  display: none;
}
.win_item .snow_special{
  padding:3px;
  position: relative;
  width:60px;
  height: 60px;
  margin:0 auto;
  text-align:center;
  background: url("../assets/img/bg_icon.png");
}
.win_item .snow_special .spec_wrap{
  width: 60px;
  height:60px;
  margin:0 auto 0;
}
.win_item .snow_special .spec_wrap img{
  border-radius: 50%;
  margin-left:-2px;
}
.win_item .spec_wrap .spec_tip{
  display: none;
  background: rgb(24 34 40 / 60%);
  position: absolute;
  color:#fff;
  font-size: 12px;
  line-height: 16px;
  min-width: 220px;
  display: none;
  bottom: 0;
  left: 0;
  z-index: 10;
  padding:1px 5px;
  border:#212d34 1px solid;
  text-align: left;
}
.win_item .spec_wrap .spec_tip.last{
  right: 0;
  left: auto;
}
.win_item .spec_wrap .spec_tip .p1{
  color:yellow;
}
.win_item .spec_wrap .spec_tip .p1.red{
  color:#ff0000;
}
.win_item .spec_wrap:hover .spec_tip{
  display: block;
}
.hero_light{
  position:absolute;
  top:0;
  left:0;
  width: 152px;
  height: 488px;
  z-index: 5;
}
.hero_light.img_active{
    animation:light 2.25s steps(1,end) forwards;
    -webkit-animation:light 2.25s steps(1,end) forwards;
}
@keyframes light{
    0%    {background: url("../assets/img/gif/t_01.png") 0 0 no-repeat;}
   1.88% {background: url("../assets/img/gif/t_02.png") 0 0 no-repeat;}
   3.77% {background: url("../assets/img/gif/t_03.png") 0 0 no-repeat;}
   5.65% {background: url("../assets/img/gif/t_04.png") 0 0 no-repeat;}
   7.54%    {background: url("../assets/img/gif/t_05.png") 0 0 no-repeat;}
   9.43% {background: url("../assets/img/gif/t_06.png") 0 0 no-repeat;}
   11.3% {background: url("../assets/img/gif/t_07.png") 0 0 no-repeat;}
   13.2% {background: url("../assets/img/gif/t_08.png") 0 0 no-repeat;}
   15%    {background: url("../assets/img/gif/t_09.png") 0 0 no-repeat;}
   16.97% {background: url("../assets/img/gif/t_10.png") 0 0 no-repeat;}
   18.86% {background: url("../assets/img/gif/t_11.png") 0 0 no-repeat;}
   20.74% {background: url("../assets/img/gif/t_12.png") 0 0 no-repeat;}
   22.63%    {background: url("../assets/img/gif/t_13.png") 0 0 no-repeat;}
   24.51% {background: url("../assets/img/gif/t_14.png") 0 0 no-repeat;}
   26.4% {background: url("../assets/img/gif/t_15.png") 0 0 no-repeat;}
   28.29% {background: url("../assets/img/gif/t_16.png") 0 0 no-repeat;}
   30.17%    {background: url("../assets/img/gif/t_17.png") 0 0 no-repeat;}
   32.06% {background: url("../assets/img/gif/t_18.png") 0 0 no-repeat;}
   33.94% {background: url("../assets/img/gif/t_19.png") 0 0 no-repeat;}
   35.83% {background: url("../assets/img/gif/t_20.png") 0 0 no-repeat;}
   37.72%    {background: url("../assets/img/gif/t_21.png") 0 0 no-repeat;}
   39.6% {background: url("../assets/img/gif/t_22.png") 0 0 no-repeat;}
   41.49% {background: url("../assets/img/gif/t_23.png") 0 0 no-repeat;}
   43.37% {background: url("../assets/img/gif/t_24.png") 0 0 no-repeat;}
   45.26%    {background: url("../assets/img/gif/t_25.png") 0 0 no-repeat;}
   47.15% {background: url("../assets/img/gif/t_26.png") 0 0 no-repeat;}
   49.03% {background: url("../assets/img/gif/t_27.png") 0 0 no-repeat;}
   50.92% {background: url("../assets/img/gif/t_28.png") 0 0 no-repeat;}
   52.8%    {background: url("../assets/img/gif/t_29.png") 0 0 no-repeat;}
   54.69% {background: url("../assets/img/gif/t_30.png") 0 0 no-repeat;}
   56.58% {background: url("../assets/img/gif/t_31.png") 0 0 no-repeat;}
   58.46% {background: url("../assets/img/gif/t_32.png") 0 0 no-repeat;}
   60.35%    {background: url("../assets/img/gif/t_33.png") 0 0 no-repeat;}
   62.23% {background: url("../assets/img/gif/t_34.png") 0 0 no-repeat;}
   64.12% {background: url("../assets/img/gif/t_35.png") 0 0 no-repeat;}
   66.01% {background: url("../assets/img/gif/t_36.png") 0 0 no-repeat;}
   67.89% {background: url("../assets/img/gif/t_37.png") 0 0 no-repeat;}
   69.78% {background: url("../assets/img/gif/t_38.png") 0 0 no-repeat;}
   71.66%    {background: url("../assets/img/gif/t_39.png") 0 0 no-repeat;}
   73.55% {background: url("../assets/img/gif/t_40.png") 0 0 no-repeat;}
   75.44% {background: url("../assets/img/gif/t_41.png") 0 0 no-repeat;}
   77.32% {background: url("../assets/img/gif/t_42.png") 0 0 no-repeat;}
   79.21%    {background: url("../assets/img/gif/t_43.png") 0 0 no-repeat;}
   81.09% {background: url("../assets/img/gif/t_44.png") 0 0 no-repeat;}
   82.98% {background: url("../assets/img/gif/t_45.png") 0 0 no-repeat;}
   84.87% {background: url("../assets/img/gif/t_46.png") 0 0 no-repeat;}
   86.75%    {background: url("../assets/img/gif/t_47.png") 0 0 no-repeat;}
   88.64% {background: url("../assets/img/gif/t_48.png") 0 0 no-repeat;}
   90.52% {background: url("../assets/img/gif/t_49.png") 0 0 no-repeat;}
   92.41% {background: url("../assets/img/gif/t_50.png") 0 0 no-repeat;}
   94.3% {background: url("../assets/img/gif/t_51.png") 0 0 no-repeat;}
   96.18% {background: url("../assets/img/gif/t_52.png") 0 0 no-repeat;}
   98.07% {background: url("../assets/img/gif/t_53.png") 0 0 no-repeat;}
   100% {background: url("../assets/img/gif/t_54.png") 0 0 no-repeat;}
}
@-webkit-keyframes light{
  0%    {background: url("../assets/img/gif/t_01.png") 0 0 no-repeat;}
   1.88% {background: url("../assets/img/gif/t_02.png") 0 0 no-repeat;}
   3.77% {background: url("../assets/img/gif/t_03.png") 0 0 no-repeat;}
   5.65% {background: url("../assets/img/gif/t_04.png") 0 0 no-repeat;}
   7.54%    {background: url("../assets/img/gif/t_05.png") 0 0 no-repeat;}
   9.43% {background: url("../assets/img/gif/t_06.png") 0 0 no-repeat;}
   11.3% {background: url("../assets/img/gif/t_07.png") 0 0 no-repeat;}
   13.2% {background: url("../assets/img/gif/t_08.png") 0 0 no-repeat;}
   15%    {background: url("../assets/img/gif/t_09.png") 0 0 no-repeat;}
   16.97% {background: url("../assets/img/gif/t_10.png") 0 0 no-repeat;}
   18.86% {background: url("../assets/img/gif/t_11.png") 0 0 no-repeat;}
   20.74% {background: url("../assets/img/gif/t_12.png") 0 0 no-repeat;}
   22.63%    {background: url("../assets/img/gif/t_13.png") 0 0 no-repeat;}
   24.51% {background: url("../assets/img/gif/t_14.png") 0 0 no-repeat;}
   26.4% {background: url("../assets/img/gif/t_15.png") 0 0 no-repeat;}
   28.29% {background: url("../assets/img/gif/t_16.png") 0 0 no-repeat;}
   30.17%    {background: url("../assets/img/gif/t_17.png") 0 0 no-repeat;}
   32.06% {background: url("../assets/img/gif/t_18.png") 0 0 no-repeat;}
   33.94% {background: url("../assets/img/gif/t_19.png") 0 0 no-repeat;}
   35.83% {background: url("../assets/img/gif/t_20.png") 0 0 no-repeat;}
   37.72%    {background: url("../assets/img/gif/t_21.png") 0 0 no-repeat;}
   39.6% {background: url("../assets/img/gif/t_22.png") 0 0 no-repeat;}
   41.49% {background: url("../assets/img/gif/t_23.png") 0 0 no-repeat;}
   43.37% {background: url("../assets/img/gif/t_24.png") 0 0 no-repeat;}
   45.26%    {background: url("../assets/img/gif/t_25.png") 0 0 no-repeat;}
   47.15% {background: url("../assets/img/gif/t_26.png") 0 0 no-repeat;}
   49.03% {background: url("../assets/img/gif/t_27.png") 0 0 no-repeat;}
   50.92% {background: url("../assets/img/gif/t_28.png") 0 0 no-repeat;}
   52.8%    {background: url("../assets/img/gif/t_29.png") 0 0 no-repeat;}
   54.69% {background: url("../assets/img/gif/t_30.png") 0 0 no-repeat;}
   56.58% {background: url("../assets/img/gif/t_31.png") 0 0 no-repeat;}
   58.46% {background: url("../assets/img/gif/t_32.png") 0 0 no-repeat;}
   60.35%    {background: url("../assets/img/gif/t_33.png") 0 0 no-repeat;}
   62.23% {background: url("../assets/img/gif/t_34.png") 0 0 no-repeat;}
   64.12% {background: url("../assets/img/gif/t_35.png") 0 0 no-repeat;}
   66.01% {background: url("../assets/img/gif/t_36.png") 0 0 no-repeat;}
   67.89% {background: url("../assets/img/gif/t_37.png") 0 0 no-repeat;}
   69.78% {background: url("../assets/img/gif/t_38.png") 0 0 no-repeat;}
   71.66%    {background: url("../assets/img/gif/t_39.png") 0 0 no-repeat;}
   73.55% {background: url("../assets/img/gif/t_40.png") 0 0 no-repeat;}
   75.44% {background: url("../assets/img/gif/t_41.png") 0 0 no-repeat;}
   77.32% {background: url("../assets/img/gif/t_42.png") 0 0 no-repeat;}
   79.21%    {background: url("../assets/img/gif/t_43.png") 0 0 no-repeat;}
   81.09% {background: url("../assets/img/gif/t_44.png") 0 0 no-repeat;}
   82.98% {background: url("../assets/img/gif/t_45.png") 0 0 no-repeat;}
   84.87% {background: url("../assets/img/gif/t_46.png") 0 0 no-repeat;}
   86.75%    {background: url("../assets/img/gif/t_47.png") 0 0 no-repeat;}
   88.64% {background: url("../assets/img/gif/t_48.png") 0 0 no-repeat;}
   90.52% {background: url("../assets/img/gif/t_49.png") 0 0 no-repeat;}
   92.41% {background: url("../assets/img/gif/t_50.png") 0 0 no-repeat;}
   94.3% {background: url("../assets/img/gif/t_51.png") 0 0 no-repeat;}
   96.18% {background: url("../assets/img/gif/t_52.png") 0 0 no-repeat;}
   98.07% {background: url("../assets/img/gif/t_53.png") 0 0 no-repeat;}
   100% {background: url("../assets/img/gif/t_54.png") 0 0 no-repeat;}
}
.win_item .img_wrap .jl_nums {
  position: absolute;
  bottom:-2px;
  width: 40px;
  left:13px;
  text-align: center;
  color: #5d8235;
  font-weight: bold;
  font-size: 12px;
  height: 14px;
  line-height: 14px;
  z-index:5;
  background: url("../assets/img/bg_num.png") 0 0 no-repeat;
  /* text-shadow: 0 1px #983b09, 1px 0 #983b09, -1px 0 #983b09, 0 -1px #983b09; */
}
.win_item .spec_wrap .jl_nums{
  position: absolute;
  bottom: -2px;
    width: 40px;
    left: 13px;
    text-align: center;
    color: #5d8235;
    font-weight: bold;
    font-size: 12px;
    height: 14px;
    line-height: 14px;
  z-index:3;
  background: url("../assets/img/bg_num.png") 0 0 no-repeat;
}
.win_item.ylq .jl_nums{
  display: none;
}
.item10.ylq .spec_wrap .jl_nums,.item16.ylq .spec_wrap .jl_nums{
  display: block;
}
.win_item .lq_btn {
  position: relative;
  display: block;
  width:96px;
  height: 32px;
  background: url("../assets/img/lq_btn.png") 0 0 no-repeat;
  margin:0 auto;
}
.win_item .lq_btn:hover {
  background-position: 0 -32px;
}
.win_item .lq_btn:active {
  background-position: 0 -64px;
}
.win_item .lq_btn.cant {
  background-position: 0 -128px;
}
.win_item .lq_btn.ylq{
  background-position: 0 -96px;
}
.win_nums{
  color: #5a752f;
  font-size: 16px;
  width: 96px;
  height: 32px;
  line-height: 32px;
  text-align:center;
  font-weight: bold;
  margin:0 auto;
}
.spec_wrap .img_tip{
  display: none;
  background: rgb(24 34 40 / 60%);
  position: absolute;
  color:#fff;
  font-size: 12px;
  line-height: 16px;
  min-width: 220px;
  display: none;
  bottom: 0;
  left: 0;
  z-index: 10;
  padding:1px 5px;
  border:#212d34 1px solid;
  text-align: left;
}
.item4 .spec_wrap .img_tip,.item8 .spec_wrap .img_tip,.item12 .spec_wrap .img_tip,.item16 .spec_wrap .img_tip{
  left: auto;
  right:0;
}
.spec_wrap:hover .img_tip{
  display: block;
}

.img_wrap .gray {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  /* -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%); */
}
.win_item.on .img_wrap .gray {
  filter: grayscale(0);
  -webkit-filter: grayscale(0);
  -moz-filter: grayscale(0);
  -ms-filter: grayscale(0);
  -o-filter: grayscale(0);
}
.win_item.ylq .img_wrap .gray {
  filter: grayscale(0);
  -webkit-filter: grayscale(0);
  -moz-filter: grayscale(0);
  -ms-filter: grayscale(0);
  -o-filter: grayscale(0);
}
</style>
